export default "__VITE_ASSET__973d62e3__"